export default function (Vue) {
        //let authenticatedUser = {};
        
        Vue.dmAuth = {
            
            authenticatedUser: {},
            
            setToken: function(token, expiration) {
                
                localStorage.setItem('token', token)
                localStorage.setItem('expiration', expiration)
            },
            getToken: function() {
                
                var token = localStorage.getItem('token');
                var expiration = localStorage.getItem('expiration');
                
                if (!token || !expiration) {
                    
                    return null;
                }
                if(Date.now() > parseInt(expiration)) {
                    this.killToken();
                    return null
                }
                return token;
            },
            killToken: function() {
                
                localStorage.removeItem('token')
                localStorage.removeItem('expiration')
            },
            isAuthenticated: function() {
                
                if (this.getToken()) {                    
                    return true;
                } else {                    
                    return false;
                }
                
            },
            setAuthenticatedUser: function(data) {                
                this.authenticatedUser=data;                
                return this;
            },
            getAuthenticatedUser: function() {
                return this.authenticatedUser;
            }
            
        }
        Object.defineProperties(Vue.prototype, {
        
            $dmAuth: {
                get: function() {
                    return Vue.dmAuth;
                }
            }
                
        });
}



// WEBPACK FOOTER //
// ./src/packages/dmAuth/DmAuth.js